export default {
    SET_VOTES(state, payload) {
        state.votes = payload;
    },

    ADD_VOTE(state, payload) {
        state.votes.push(payload);
    },
};
